/**
 * Portal Component
 * Renders component at the end of body for modals, tooltips, etc.
 */

import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: ReactNode;
  id?: string;
}

const Portal: React.FC<PortalProps> = ({ children, id = "portal-root" }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    // Create portal element if it doesn't exist
    if (!document.getElementById(id)) {
      const portalElement = document.createElement("div");
      portalElement.id = id;
      document.body.appendChild(portalElement);
    }
  }, [id]);

  if (!mounted) return null;

  const element = document.getElementById(id);
  if (!element) return null;

  return createPortal(children, element);
};

export default Portal;
